import React from 'react';
import ReactMarkdown from "react-markdown";

import courses from "../json/course.json";

import books from "../images/books.png";

function Courses() {

    function buildImageLink(link) {
        const images = [["books", books]];
        for (let i = 0; i < images.length; i++) {
            if (images[i][0] === link) {
                
                return images[i][1];
            }
        }
    }

    return (
        <div className="content">
            <header>
                <h1 className="title has-text-centered has-text-white">Courses</h1>
                <p>The courses I have participated in when I'm not employed, covering subjects in IT and other fields.</p>
            </header>
            {courses.courses.map((course, index = 0) => {
                return (
                    <section className="section" key={index++}>
                        <div className="columns">
                            <div className="column is-narrow">
                                <figure>
                                    <img className="image is-128x128" src={buildImageLink(course.image.src)} alt={course.image.alt} />
                                    <p className="is-size-5">{course.course.year}</p>
                                </figure>
                            </div>
                            <div className="column">
                                <div className="content">
                                    <h2 className="subtitle">{course.course.title}</h2>
                                    <ReactMarkdown children={course.body} />
                                </div>
                            </div>
                        </div>

                    </section>
                )
            })}
        </div>
    )
}

export default Courses;